"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printValidationMessage = printValidationMessage;
function printValidationMessage(validationItem) {
    if (validationItem.pass) {
        return "";
    }
    switch (validationItem.type) {
        case "length-min":
            return `Value must be at least ${validationItem.value} characters`;
        case "length-max":
            return `Value must be at most ${validationItem.value} characters`;
        case "amount-min":
            return `Value must be at least ${validationItem.value}`;
        case "amount-max":
            return `Value must be at most ${validationItem.value}`;
        case "date-range-min":
            return `Date must be on or after ${validationItem.value}`;
        case "date-range-max":
            return `Date must be on or before ${validationItem.value}`;
        case "enum-option":
            return `Value must be a valid option`;
        case "value-type":
            return mapValueTypeToLabel(validationItem.value);
        default:
            return "Value must be valid";
    }
}
function mapValueTypeToLabel(type) {
    switch (type) {
        case "email":
            return "Value must be a valid email address";
        case "tel":
            return "Value must be a valid phone number: 10 digits, no spaces or dashes";
        case "url":
            return "Value must be a valid URL";
        case "date":
            return "Value must be a valid date";
        default:
            return "Value must be valid";
    }
}
//# sourceMappingURL=print-validation-message.js.map